import { Observable, of } from 'rxjs';
import { filter, take, timeout } from 'rxjs/operators';

/**
 * Release scan, 1 Oct. The session's API token, or '' after `ms` without one.
 *
 * On a cold load a query can go out before GetSession has set the token, and
 * the server answers "Forbidden resource" as a normal 200. Waiting here, with a
 * timeout so nothing can hang, is the pattern the notification feed uses
 * (#1844). With a token already in place it emits at once.
 */
export function untilSessionToken(
  authToken$: Observable<string | null | undefined>,
  ms: number
): Observable<string> {
  return authToken$.pipe(
    filter((token): token is string => !!token),
    take(1),
    timeout({ first: ms, with: () => of('') })
  );
}
